import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";

export const jobCoachingActivitiesService = createCrudService("job_coaching_activities", [], router);